export default {
  appURL: process.env.REACT_APP_BASE || 'http://localhost:3000',
  baseApiUrl:
    process.env.REACT_APP_API_BASE || 'https://testing-api.tagmango.com',
};
